import React, {Component} from 'react';
import ReferenceStarsRating from './reference_stars_rating';
import StarsRatingField from './stars_rating_field';
import {GroupTypes} from '../constants.js.erb';

const DISPLAYED_TRIAL_LOCATIONS_COUNT = 5;
export default class ReferencesWeeklyDigest extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderReferencesGroup(name, references) {
    if (!references || references.length === 0) return null;
    return (
      <div key={name}>
        <h3>{name}</h3>
        <hr/>
        {references.map(t => this.renderReference(t))}
      </div>
    )
  }

  renderReferences() {
    let {data} = this.props;
    return (
      <div id="references">
        <h2>References</h2>

        {data.references.cancer_types.map(({label, items}) => this.renderReferencesGroup(label, items))}
        {data.references.cancer_categories.map(({label, items}) => this.renderReferencesGroup(label, items))}
        {this.renderReferencesGroup("Solid Tumors", data.references.solid_tumors)}
        {this.renderReferencesGroup("Liquid Tumors", data.references.liquid_tumors)}
        {this.renderReferencesGroup("Cancer", data.references.other)}
      </div>
    )
  }

  renderReference(reference) {
    return (
      <div className="reference" key={reference.reference_id}>
        <h4><a href={reference.source_link} target="_blank">{reference.name}</a></h4>
        <p>{reference.significant_finding}</p>

        <div className="populations">
          {reference.populations.map((population, index) => {
            return (
              <div className="population" key={index}>
                <StarsRatingField value={population.highest_ranked_efficacy_data_rating} extraOptions={ReferenceStarsRating.EXTRA_OPTIONS} valueComponentOnly={true} />
                  - {population.name}. {population.number_of_patients_treated} patients treated with {population.interventions.join(', ')}.
                <p>{population.efficacy_description} (Safety is {population.highest_ranked_safety_data_rating})</p>
              </div>
            )})
          }
        </div>

      </div>
    )
  }

  renderTrial(trial) {
    let location_names = trial.location_names.slice(0, DISPLAYED_TRIAL_LOCATIONS_COUNT).join(', ');
    let locations_prefix;
    if (trial.locations_count > DISPLAYED_TRIAL_LOCATIONS_COUNT) {
      locations_prefix = `${trial.locations_count} locations including:`
    }
    return (
      <div className="trial" key={trial.trial_id}>
        <h4><a href={trial.study_url} target="_blank">{trial.name}</a></h4>
        <p>{trial.brief_summary}</p>
        FOR
        <ul>
          {trial.population_names.map((population_name, index) =>
            <li key={index}>{population_name}</li>
          )}
        </ul>

        <h5>Treatment Groups</h5>
        {trial.groups.map((group, index) => {
          let group_type = GroupTypes[group.type];
          return (
            <div key={index}>
              <p>{index + 1} {group_type}</p>
              <p>{group.description}</p>
              <ul>
                {group.items.map(item => {
                  let key = item.id + '::' + item.type;
                  let moa_type;
                  if (item.type === 'interventions') {
                    moa_type = <span className="moa_type">{item.moa_type}</span>;
                  }

                  return <li key={key}>{item.name} {moa_type}</li>
                })}
              </ul>
            </div>
          );
        })}

        <h5>Locations</h5>
        <p>{locations_prefix} {location_names}</p>

        <h5>Sponsor</h5>
        {trial.lead_sponsor.name}

        <h5>Trial ID</h5>
        {trial.identifier}
      </div>

    )
  }

  renderTrialsGroup(name, trials) {
    if (!trials || trials.length === 0) return null;
    return (
      <div key={name}>
        <h3>{name}</h3>
        {trials.map(t => this.renderTrial(t))}
      </div>
    )
  }

  renderTrials() {
    let {data} = this.props;
    return (
      <div id="trials">
        <h2>Trials</h2>

        {data.trials.cancer_types.map(({label, items}) => this.renderTrialsGroup(label, items))}
        {data.trials.cancer_categories.map(({label, items}) => this.renderTrialsGroup(label, items))}
        {this.renderTrialsGroup("Solid Tumors", data.trials.solid_tumors)}
        {this.renderTrialsGroup("Liquid Tumors", data.trials.liquid_tumors)}
        {this.renderTrialsGroup("Cancer", data.trials.other)}
      </div>
    )
  }

  render() {
    return (
      <div id="weekly_digest">
      <h1> Weekly Digest</h1>
        {this.renderReferences()}
        {this.renderTrials()}
      </div>
    );
  }
}
